const TestimonialsSection = () => {
    return (
        <section id="testimonials" className="py-20 bg-blue-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-14">
                    <span className="text-blue-600 font-semibold text-sm uppercase tracking-widest">Customer Stories</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">What Our Customers Say</h2>
                </div>

                <div className="flex flex-col items-center text-center max-w-md mx-auto">
                    <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-5">
                        <i className="fas fa-comments text-blue-500 text-3xl"></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">Coming Soon</h3>
                    <p className="text-gray-500 text-sm">
                        We're collecting stories from our early customers — check back soon.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default TestimonialsSection;
